<template>
  <div
    class="d-flex"
  >
    <SubmitMenu
      label="件数"
      suffix="件"
      :value="caseNumberInput"
      :min="10"
      :max="caseNumberMax >= 10 ? caseNumberMax : null"
      @input="$store.dispatch('list/setCaseNumberInput',Number($event))"
    />
    <SubmitMenu
      label="積載量"
      suffix="ℓ"
      :value="oilSupplyInput"
      :min="1000"
      @input="$store.dispatch('list/setOilSupplyInput',Number($event))"
    />
  </div>
</template>

<script>
import SubmitMenu from './SubmitMenu'
import { mapState, mapGetters } from 'vuex'
export default {
  components: {
    SubmitMenu
  },
  computed: {
    ...mapState('list', ['caseNumberInput', 'oilSupplyInput']),
    ...mapGetters('list', ['caseNumberMax'])
  }
}
</script>
